module.exports = __webpack_public_path__ + "img/athlete-soccer-background.08ee4543.svg";